import React, { useState, useContext } from "react";
import PopDialog from "../components/popupdialog";
import { ContextProvider } from "../providers/app.provider";
import { Button } from "semantic-ui-react";

const AddNotes = () => {
  const [modalOpen, setOpen] = useState(false);
  const openModal = () => {
    setOpen(!modalOpen);
  };
  const closeModal = () => {
    setOpen(false);
  };

  const details = {
    title: "Notes",
    header: "Please insert additional notes at below",
    content: [],
  };

  const { notes, notesDispatch } = useContext(ContextProvider);

  const handleChange = (value) => {
    notesDispatch({ type: "NOTES_SUBMIT", payload: value });
  };
  const reset = () => {
    notesDispatch({ type: "NOTES_RESET", payload: "" });
  };

  return (
    <span>
      <Button onClick={openModal} color="orange" floated="right">
        Add Notes
      </Button>
      <PopDialog
        modalOpen={modalOpen}
        closeModal={closeModal}
        details={details}
        value={notes}
        handleChange={handleChange}
        reset={reset}
        onSubmit={() => {}}
        status={true}
      />
    </span>
  );
};

export default AddNotes;
